import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import {bindActionCreators} from 'redux';

import CartInventory from '../components/CartInventory';
import { getPriceLevelSelectionsByEvent } from '../../ticket-picker/selectors/tickets';
import { getProductSalesByEvent, cartHasDependentProducts } from '../../product-picker/selectors/products';
import { getGroupedBundleSalesByEvent } from '../../bundle-picker/selectors/bundles';
import {updateTicketQuantities} from '../../../actions/tickets';
import {updateProductQuantities} from '../../../actions/product-sales';
import {updateBundleQuantities} from '../../../actions/bundle-sales';
import { deleteReservation } from '../../../actions/reservation';
import ContainerProps from './CartInventoryContainerComponent';
import { getLoadingLevels, getLoadingProductConfig, getLoadingBundles } from 'checkout/selectors/cart';
import { getEventOrUpsellVenueByEventId, getMainEvent } from '../../../selectors/event';

class CartInventoryContainer extends Component<ContainerProps> {
    render() {
        return(
            <CartInventory
                locale={this.props.locale}
                levels={this.props.priceLevels}
                onSelectionChanged={this.selectionChanged}
                products={this.props.products}
                onProductSelectionChange={this.productSelectionChange}
                loadingLevels={this.props.loadingLevels}
                loadingProductConfig={this.props.loadingProductConfig}
                hasDependentProducts={this.props.hasDependentProducts}
                bundles={this.props.bundles}
                onBundleSelectionChange={this.bundleSelectionChange}
                loadingBundles={this.props.loadingBundles}
                clearReservation={this.clearReservation}
                isPackage={this.props.isPackage}
                eventName={this.props.eventName}
                eventInventory={this.props.eventInventory}
                eventStart={this.props.eventStart}
                eventEnd={this.props.eventEnd}
                venue={this.props.venue}
                onLoadingStatusChanged={this.props.onLoadingStatusChanged}
            />
        )
    }

    selectionChanged = (value, levelId, upsellId = null) => {
        const quantities = {
            tickets: [
                {
                    quantity: value,
                    pricing_level_id: levelId,
                    event_id: this.props.eventId
                }
            ]
        };
        if (upsellId) {
            quantities.tickets[0].listing_upsell_id = upsellId;
        }
        const token = this.props.token;
        const secret = this.props.secret;
        const refetch = true;
        const updateDonations = this.props.hasDonations ? true : false;

        this.props.updateTicketQuantities(quantities, token, secret, refetch, updateDonations, upsellId);
    };

    productSelectionChange = (value, configurationId) => {
        this.props.updateProductQuantities({products: [{quantity: value, product_configuration_id: configurationId, event_id: this.props.eventId}]}, this.props.token, this.props.secret);
    };

    bundleSelectionChange = (value, bundle) => {

        const productConfigs = this.getBundleProductConfig(bundle.contents.products, value);
        const quantities = {
            bundles: [
                {
                    quantity: value,
                    productConfigs: productConfigs,
                    bundleId: bundle.bundle_id,
                    eventId: this.props.eventId,
                    bundleSaleIds: bundle.bundle_sale_ids
                }
            ]
        };
        const token = this.props.token;
        const secret = this.props.secret;
        const refetch = true;
        const updateDonations = this.props.hasDonations ? true : false;

        this.props.updateBundleQuantities(quantities, token, secret, refetch, updateDonations);
    };

    getBundleProductConfig = (products, duplicationValue) => {
        let configurations = {};
        for (const productId in products) {
            let configurationIds = [];
            if (duplicationValue > 0) {
                for (let i = 0; i < duplicationValue; i++) {
                    Object.keys(products[productId]).forEach(configId => {
                        configurationIds.push(configId);
                    });
                }
            } else {
                Object.keys(products[productId]).forEach(configId => {
                    configurationIds.push(configId);
                });
            }

            configurations[productId] = configurationIds;
        }

        return configurations;
    }

    clearReservation = () => {
        this.props.deleteReservation();
    }
}

const mapStateToProps = (state, props) => {
    let eventId = props.eventId ? +props.eventId : +getMainEvent(state)?.event?.event_id;
    let eventName = 'Event';
    let eventStart = '';
    let eventEnd = '';

    // grab event name from reserved items
    for (let itemArray of [state.tickets.tickets, state.productSales.products, state.bundleSales.bundles]) {
        for (let inventoryItem of itemArray) {
            if (+inventoryItem.event_id === +eventId) {
                eventName = inventoryItem.event_name;
                eventStart = inventoryItem.event_start;
                eventEnd = inventoryItem.event_end;
                break;
            }
        }
    }

    const bundleSalesByEvent = getGroupedBundleSalesByEvent(state);
    const bundleSales = Array.isArray(bundleSalesByEvent[eventId]) ? bundleSalesByEvent[eventId] : [];
    const venue = getEventOrUpsellVenueByEventId(state, eventId);

    return {
        locale: state.intl.locale,
        eventId,
        eventName,
        eventStart,
        eventEnd,
        venue,
        priceLevels: getPriceLevelSelectionsByEvent(state)[eventId],
        products: getProductSalesByEvent(state)[eventId],
        bundles: bundleSales,
        token: state.reservation.token,
        secret: state.reservation.secret,
        loadingLevels: getLoadingLevels(state),
        loadingProductConfig: getLoadingProductConfig(state),
        hasDependentProducts: cartHasDependentProducts(state),
        loadingBundles: getLoadingBundles(state),
        hasDonations: state.donations.hasDonations,
        isPackage: !!getMainEvent(state)?.event?.isPackage,
    }
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        updateTicketQuantities,
        updateProductQuantities,
        updateBundleQuantities,
        deleteReservation,
    }, dispatch);
};

CartInventoryContainer.propTypes = {
    eventId: PropTypes.number,
    priceLevels: PropTypes.array,
    products: PropTypes.array,
    bundles: PropTypes.array,
    token: PropTypes.string.isRequired,
    secret: PropTypes.string.isRequired,
    onLoadingStatusChanged: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(CartInventoryContainer)
